






































import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VMultiSwitcher from "@/components/VMultiSwitcher.vue";
import SelectOption from "@/interfaces/SelectOption";
import TaxonomySelectV2 from "@/components/TaxonomySelectV2.vue";
import {
  BenchmarkGranularity,
  BenchmarkTaxonomy,
} from "@/models/interfaces/Benchmark";

@Component({
  components: {
    TaxonomySelectV2,
    VModal,
    VMultiSwitcher,
  },
})
export default class BenchmarkModal extends Vue {
  @Prop({ default: "Imposta benchmark" }) readonly title?: string;
  @Prop({ required: true }) readonly initialGranularity?: BenchmarkGranularity;
  @Prop({ required: true }) readonly initialTaxonomy?: BenchmarkTaxonomy;

  modal!: VModal;

  private granularityItems: Array<SelectOption> = [
    { id: "companies", text: "Azienda" },
    { id: "brands", text: "Brand" },
    { id: "products", text: "Prodotto" },
  ];

  granularity: BenchmarkGranularity = "companies";
  taxonomy: BenchmarkTaxonomy = {
    sector: [],
    category: [],
    class: [],
  };

  async mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  protected onCancel() {
    this.hide();
  }

  protected onConfirm() {
    this.$emit("confirm", {
      taxonomy: this.taxonomy,
      granularity: this.granularity,
    });
    this.hide();
  }

  show() {
    this.granularity = this.initialGranularity!;
    this.taxonomy = this.initialTaxonomy!;
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }
}
